"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const config_1 = require("config");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
const PMP_Login_Image_png_1 = __importDefault(require("images/PMP_Login_Image.png"));
const forms_1 = require("../../forms");
function ApplicationFinder({ getCreditApplicationsByStatus, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const handleSubmit = (formValues) => {
        setSubmitting(true);
        getCreditApplicationsByStatus(formValues, 'prequalified')
            .then(() => {
            history.push(config_1.APPLICATION_FOUND_URL);
        })
            .catch(() => {
            getCreditApplicationsByStatus(formValues, 'pending')
                .then(() => {
                history.push(config_1.APPLICATION_FOUND_URL);
            })
                .catch(() => {
                history.push(config_1.NO_APPLICATIONS_URL);
            });
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "application-finder-container min-height-600", children: [(0, jsx_runtime_1.jsx)("div", { className: "left-content-container", children: (0, jsx_runtime_1.jsx)("img", { src: PMP_Login_Image_png_1.default, alt: "Person holding an Alphaeon credit card" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "right-content-container", children: [(0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)("img", { className: "logo", src: Alphaeon_Patient_Financing_Logo_png_1.default, alt: "Alphaeon logo" }), (0, jsx_runtime_1.jsx)("h1", { children: "Let's Find Your Application" })] }), (0, jsx_runtime_1.jsx)(forms_1.ApplicationFinderForm, { handleSubmit: handleSubmit, submitting: submitting }), (0, jsx_runtime_1.jsxs)("p", { children: ["Haven't applied yet? ", (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.CREDIT_PORTAL_URL, children: "Apply" })] })] })] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {
    getCreditApplicationsByStatus: apiActions.getCreditApplicationsByStatus,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(ApplicationFinder);
